import { Component, OnInit } from '@angular/core';
import { PzService, Statistic } from '../../service/pz.service';
import { Winner } from '../../utils/utils';

// Dummy statistics
// const dummyStatistics1: Statistic = {
//   round: 1,
//   estimatedPricePlayer1: 8,
//   estimatedPricePlayer2: 6,
//   priceAmazon: 9,
//   differencePricePlayer1: 1,
//   differencePricePlayer2: 3,
//   winner: Winner.PLAYER_1,
//   points: 1,
//   senfkarteUsed: false,
//   articleUrl:
//     'https://www.amazon.de/Mundschutzmaske-zertifiziert-Atemschutzmasken-hygienische-Einzelverpackung/dp/B08TTYBD3K/ref=zg-bs_sports_1/258-4861201-5120361?pd_rd_w=agPfD&pf_rd_p=25d6d4f8-2717-4a48-97fc-9b1a75c8d109&pf_rd_r=AGQ7YQ3C8BRKKY2Y44RZ&pd_rd_r=388e12dc-70a6-4e6f-840b-77546d542c08&pd_rd_wg=nBLma&pd_rd_i=B08TTYBD3K&psc=1',
//   articleTitle:
//     'EUROPAPA® 20x FFP2 Schwarz Maske 5-Lagen Mundschutzmaske CE Stelle zertifiziert Atemschutzmasken hygienische Einzelverpackung EU 2016/425 : Amazon.de: Sport & Freizeit',
// };
//
// const dummyStatistics2: Statistic = {
//   round: 2,
//   estimatedPricePlayer1: 3.99,
//   estimatedPricePlayer2: 9.99,
//   priceAmazon: 9.99,
//   differencePricePlayer1: 6,
//   differencePricePlayer2: 0,
//   winner: Winner.PLAYER_2,
//   points: 10,
//   senfkarteUsed: false,
//   articleUrl:
//     'https://www.amazon.de/Garnier-Solaire-Sonnenschutz-Milch-feuchtigkeitsspendende-Sonnencreme/dp/B082VMYWWK/?_encoding=UTF8&pd_rd_w=Ge7ZO&content-id=amzn1.sym.0bf9ab1e-db90-4058-8c91-2e3e5b4712b7&pf_rd_p=0bf9ab1e-db90-4058-8c91-2e3e5b4712b7&pf_rd_r=N1NHN46KVDDS0F3S4537&pd_rd_wg=zRre4&pd_rd_r=4fd68a03-6b86-45ae-b469-88553f8347b8&ref_=pd_gw_ci_mcx_mr_hp_atf_m',
//   articleTitle:
//     'Garnier Sonnenschutz-Milch, LSF 30, feuchtigkeitsspendende Sonnencreme mit Shea Butter, Ambre Solaire, (1 x 200 ml) : Amazon.de: Beauty',
// };

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
})
export class StatisticsComponent implements OnInit {
  public statistics: Statistic[];
  public displayArticleInfoDialog = false;
  public statisticArticleUrl: string;
  public statisticArticleTitle: string;

  constructor(private pzService: PzService) {}

  public ngOnInit(): void {
    this.statistics = this.pzService.statistics;
    // this.statistics.push(dummyStatistics1); // Just for testing purpose
    // this.statistics.push(dummyStatistics2); // Just for testing purpose
  }

  public isStatisticsAvailable(): boolean {
    return this.statistics.length > 0;
  }

  public mapWinner(winner: Winner): string {
    return this.pzService.mapWinner(winner);
  }

  public mapSenfkarteState(senfkarteUsed: boolean): string {
    return this.pzService.mapSenfkarteState(senfkarteUsed);
  }

  public showArticleInfoDialog(
    statisticArticleUrl: string,
    statisticArticleTitle: string
  ): void {
    this.displayArticleInfoDialog = true;
    this.statisticArticleTitle = statisticArticleTitle;
    this.statisticArticleUrl = statisticArticleUrl;
  }
}
